export default {
  label: '矿山行业专家',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '矿山行业专家是矿业领域的高级技术人员，负责提供专业技术支持和指导',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '参与矿山项目的技术论证工作，解决技术难题',
          id: '0-2-1',
        },
        {
          label: '提供矿山开采技术难题的解决方案，并对现场进行技术支持',
          id: '0-2-2'
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '拥有深厚的采矿工程理论知识和实践经验',
          id: '0-3-1',
        },
        {
          label: '具备良好的沟通能力和团队协作精神',
          id: '0-3-2',
        }
      ]
    }
  ]
};